import axios from "axios";
import { serverAddress } from "constants";

const axiosInstance = axios.create({
  baseURL: serverAddress,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.data) {
      throw new Error(error.response.data.message || "Request failed");
    }
    throw error;
  }
);
const token = localStorage.getItem("token");

const config = (token) => ({
  headers: {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  },
});

const organizationId = localStorage.getItem("organizationId");

// Helper function to sanitize numeric fields - converts empty strings to 0
const sanitizeNumeric = (value) => {
  if (value === '' || value === null || value === undefined) {
    return 0;
  }
  const parsed = parseFloat(value);
  return isNaN(parsed) ? 0 : parsed;
};


export const fetchAllLoans = async (
    page = 1,
    limit = 10,
    startDate = "",
    endDate = "",
    status = "",
    employeeId = ""
  ) => {
    try {
      const params = {
        page: page,
        limit: limit,
        startDate: startDate,
        endDate: endDate,
        status: status,
        employeeId: employeeId,
      };
      const response = await axiosInstance.get(`/loan/all?organizationId=${organizationId}`, {
        ...config(token),
        params,
      });
  
      if (response.status === 200 && !response.data.error) {
        return response.data;
      } else {
        throw new Error("Error fetching loans");
      }
    } catch (error) {
      throw error;
    }
  };
  


  export const repayLoan = async (
    loanLedgerId = "",
    repaymentDate = "",
    repaidAmount = ""
  ) => {
    try {
      const response = await axiosInstance.post(
        "/loan/repay",
        {
          loan_ledger_id: loanLedgerId,
          repayment_date: repaymentDate,
          repaid_amount: sanitizeNumeric(repaidAmount)
        },
        config(token)
      );
  
      if (response.status === 200 && !response.data.error) {
        return response.data;
      } else {
        throw new Error("Error repaying loan");
      }
    } catch (error) {
      throw error;
    }
  };
  
  export const repayLoanAndUpdateSalary = async (
    loanLedgerId = "",
    repaymentDate = "",
    repaidAmount = ""
  ) => {
    try {
      const response = await axiosInstance.post(
        "/loan/repay/salaryupdate",
        {
          loan_ledger_id: loanLedgerId,
          repayment_date: repaymentDate,
          repaid_amount: sanitizeNumeric(repaidAmount)
        },
        config(token)
      );
  
      if (response.status === 200 && !response.data.error) {
        return response.data;
      } else {
        throw new Error("Error repaying loan");
      }
    } catch (error) {
      throw error;
    }
  };

// Fetch MRN list API

export const fetchLoanDetails = async (loanId) => {
  try {
    const response = await axiosInstance.get(`/loan/${loanId}`, config(token));

    if (response.status === 200 && !response.data.error) {
      return response.data?.loan;
    } else {
      throw new Error("Error fetching loan details");
    }
  } catch (error) {
    throw error;
  }
};

export const createLoan = async (employeeId, loanAmount) => {
  try {
    const response = await axiosInstance.post(
      `/loan/create?organizationId=${organizationId}`,
      {
        employee_id: employeeId,
        loan_amount: sanitizeNumeric(loanAmount),
      },
      config(token)
    );

    if (response.status === 200 && !response.data.error) {
      return response.data;
    } else {
      throw new Error("Error creating loan");
    }
  } catch (error) {
    throw error;
  }
};


export const fetchEmployeeLoanBalances = async () => {
  try {
    const response = await axiosInstance.get("/loan/employee/balances", config(token));

    if (response.status === 200 && !response.data.error) {
      return response.data.employeeLoanBalances;
    } else {
      throw new Error("Error fetching employee loan balances");
    }
  } catch (error) {
    throw error;
  }
};


export default axiosInstance;
